import BaseViz from './BaseViz'
import LineChartChart from '../charts/LineChartChart'
import LineChartDataController from '../viz_behaviors/LineChartDataController'
import { encodeDate } from '@/utils/dates.js'

export default class LineChartViz extends BaseViz {
  static chartClass = LineChartChart
  static defaultConfig = {
    mode: {
      type: String,
      default: 'lines',
      options: ['lines', 'areas'],
    },
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'],
        nonEditable: true,
      },
    },
    AxisHelper: {
      y: {
        trimThreshold: {
          nonEditable: true,
        },
      },
      x: {
        trimThreshold: {
          nonEditable: true,
        },
        showTickValues: {
          nonEditable: true,
        },
      },
    },
    TooltipBehavior: {
      getHtml: function(d) {
        return `<div class="columns">
          <div class="column"><p class="important">
            ${d.label}
          </p><p>
            ${encodeDate(d.id)}
          </p></div>
          <div class="column"><p class="value">
            ${this.valueWithUnit(d.value, 'y_1')}
          </p></div>
        </div>`
      },
    },
    LegendBehavior: {
      icon: 'line',
    },
  }
  static dataControllerClass = LineChartDataController
}
